import htmlAttributes from 'html-attributes';

export const HtmlAttributes = new Set(Object.values(htmlAttributes));
